import Styled from 'styled-components';

const CommentsMsgHeaderStyle = Styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  position:relative;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #575757;
`;

const CommentsMsgStyle = Styled.div`
  display: flex;
  height: 40px;
  justify-content: center;
  align-items: center;
  padding: 20px 26px;
  border-right: 1px solid #E9E9E9;
  border-left: 1px solid #E9E9E9;
  font-size: 14px;
  font-weight: 400;
  color: #575757;
  width: 100%;
`;

export { CommentsMsgHeaderStyle, CommentsMsgStyle };
